//@import dependencies
import React from 'react'
import {Helmet} from 'react-helmet'
//@end

// @ADD Component types
interface ITitleCommonLayoutProps {
  title: string | null
}

const TitleCommonLayout: React.FC<ITitleCommonLayoutProps> = (props) => {
  const defaultTitle = 'App'
  return (
    <Helmet>
      <title>{props.title ? props.title : defaultTitle}</title>
    </Helmet>
  )
}

export default TitleCommonLayout
